<template>
  <div v-if="visible" :class="$style.container">
    <transition name="fade" appear>
      <div :class="$style.overlay" @click.stop="handleClose"></div>
    </transition>
    <transition name="bottom-animate" appear>
      <slot />
    </transition>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
  name: 'BaseDialog',
  props: {
    value: Boolean,
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.visible = val;
      },
    },
    visible: {
      handler(val) {
        if (val) {
          disableBodyScroll(document.body);
        } else {
          enableBodyScroll(document.body);
        }

        this.$emit('input', val);
      },
    },
  },
  methods: {
    handleClose() {
      this.visible = false;

      this.$nextTick(() => {
        this.$emit('close');
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    width: 100%
    height: 100%
    position: fixed
    top: 0
    left: 0
    display: flex
    justify-content: center
    z-index: 1000

  .overlay
    width: 100%
    height: 100%
    position: absolute
    top: 0
    left: 0
    background-color: #131212
    opacity: 0.2
</style>

<style lang="sass" scoped>
  .bottom-animate-enter-active
    transition: transform .5s

  .bottom-animate-enter
    transform: translateY(100%)
</style>
